import React from "react";
import PropTypes from "prop-types";

// COMPONENTS
import ActivityIndicator from "@components/ActivityIndicator/ActivityIndicator";

// HELPERS
import { createClassName } from "@helpers/utils";


export default class Button extends React.PureComponent {
    static propTypes = {
        label: PropTypes.string.isRequired,
        busy: PropTypes.bool,
        size: PropTypes.string,
        type: PropTypes.string,
        filled: PropTypes.bool,
        appearance: PropTypes.string,
        accentColor: PropTypes.string,
        disabled: PropTypes.bool,
        fullWidth: PropTypes.bool,
        onClick: PropTypes.func,
    }
    static defaultProps = {
        busy: false,
        type: "button",
        filled: true,
        disabled: false,
        fullWidth: false,
    }
    
    click() {
        this.buttonRef.click();
    }

    render() {
        const { props } = this;
        const { name, label, busy, size, type, filled, accentColor, disabled, fullWidth, onClick } = props;
        const appearance = !accentColor ? props.appearance : null;
        const classes = createClassName(props.className, {
            "Button": true,
            "full-width": fullWidth === true,
            "busy": busy === true,
            "small": size === "small",
            "filled": filled === true,
            [appearance]: !!appearance,
        });
        const style = {
            backgroundColor: filled && accentColor ? accentColor : undefined,
            color: !filled && accentColor ? accentColor : undefined,
            borderColor: !filled && accentColor ? accentColor : undefined,
            ...props.style,
        };

        return (
            <button
                name={ name } 
                ref={ ref => this.buttonRef = ref }
                style={ style }
                className={ classes }
                type={ type }
                disabled={ disabled }
                onClick={ onClick }
                data-interactive=""
            >
                <div className="Button-label">{ label }</div>
                <ActivityIndicator busy={ busy } color={ !filled ? accentColor : undefined } />
            </button>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Button/Button.js